import { LazySPItemsViewCommandBar } from './spDocLibView';

import { observer } from 'mobx-react-lite';
import * as React from 'react';

const FilesHubCommandBar = observer(function FilesHubCommandBar(props: any) {
    return <LazySPItemsViewCommandBar />;
});
export default FilesHubCommandBar;
